import { render, staticRenderFns } from "./ExamIndex.vue?vue&type=template&id=6e08df98&scoped=true&"
import script from "./ExamIndex.vue?vue&type=script&lang=ts&"
export * from "./ExamIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08df98",
  null
  
)

export default component.exports